import { useEffect, useState } from "react";
import { Link, useRouter } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/auth-context";
import type { AuthUser } from "../auth/session";
import { CenteredPage } from "../components/centered-page";

// Rücksprung von Cognito (/callback?code=…&state=…). Tauscht den Code gegen
// Tokens und springt dann zur ursprünglich angefragten Seite.

// Ergebnis auf Modulebene merken: React ruft Effekte in der Entwicklung
// absichtlich zweimal auf (StrictMode). Der Code darf aber nur EINMAL
// eingelöst werden – ein zweiter Versuch würde scheitern.
let pending: Promise<{ user: AuthUser; returnTo: string }> | null = null;

export function CallbackPage() {
  const { t } = useTranslation();
  const { session, setUser } = useAuth();
  const router = useRouter();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    pending ??= session.completeLogin(window.location.href);
    let active = true;
    pending.then(
      ({ user, returnTo }) => {
        if (!active) return;
        setUser(user);
        // replace: /callback?code=… soll nicht in der Browser-Historie bleiben.
        router.history.replace(returnTo);
      },
      () => {
        if (active) setFailed(true);
      },
    );
    // Aufräumfunktion: läuft, wenn die Komponente verschwindet.
    return () => {
      active = false;
    };
  }, [session, setUser, router]);

  return (
    <CenteredPage>
      {failed ? (
        <div className="flex flex-col gap-4">
          <p role="alert" className="text-sm text-error-fg">
            {t("callback.failed")}
          </p>
          <Link to="/" className="text-sm text-link-fg hover:underline">
            {t("app.backToStart")}
          </Link>
        </div>
      ) : (
        <p className="text-sm text-ink-muted">{t("callback.working")}</p>
      )}
    </CenteredPage>
  );
}
